import gsap from 'gsap'

function invertZIndex(element, totalLength, index) {
  return gsap.set(element, {
    zIndex: totalLength - index,
  })
}

function fadeContentOnScroll(element) {
  let el_slide_content = element.querySelector('.full-width-cta-slide__content')

  gsap
    .timeline({
      scrollTrigger: {
        trigger: element,
        start: '95% bottom',
        toggleActions: 'restart reset play reverse',
      },
    })
    .to(el_slide_content, {
      opacity: 1,
      duration: 1,
      ease: 'linear',
    })
}

export default function init() {
  let els_project = Array.from(
    document.querySelectorAll('.homepage-projects .homepage-project')
  )

  els_project.forEach((el_project, index) => {
    invertZIndex(el_project, els_project.length, index)
    fadeContentOnScroll(el_project)
  })
}
